module.exports = __webpack_public_path__ + "img/instagram-post.4a851b75.svg";